// extracted by mini-css-extract-plugin
export default {"page":"wDTtf","saleBanners":"eL5H_","divider":"H9AOJ ZdH1P","footerText":"TSnnz ZdH1P"};